import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";
import AccountSidebar from "@/components/account/AccountSidebar";

export default function Profile() {
  const { user, refreshMe } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [mobile, setMobile] = useState(user?.mobile || "");
  const save = async () => {
    await api.put("/users/me", { name, mobile });
    await refreshMe();
    toast.success("Profile updated");
  };
  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid lg:grid-cols-[240px_1fr] gap-6">
      <AccountSidebar/>
      <section className="bg-white border border-slate-100 rounded-2xl p-6">
        <h1 className="font-display text-2xl font-bold mb-4">My Profile</h1>
        <div className="grid sm:grid-cols-2 gap-4">
          <Input label="Name" value={name} onChange={setName} testid="profile-name"/>
          <Input label="Mobile" value={mobile} onChange={setMobile} testid="profile-mobile"/>
          <Input label="Email" value={user?.email} readOnly/>
        </div>
        <button data-testid="profile-save" onClick={save} className="btn-primary-sf mt-6 px-6 py-2.5 rounded-full text-sm font-semibold">Save Changes</button>
      </section>
    </main>
  );
}
function Input({ label, value, onChange, testid, readOnly }) {
  return <label className="block"><span className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1">{label}</span>
    <input data-testid={testid} value={value||""} readOnly={readOnly} onChange={e=>onChange&&onChange(e.target.value)} className={`w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm ${readOnly?"text-slate-500":""}`}/></label>;
}
